

export const ConceptHerTrack = ()=>{
    fbq('track', 'PageView')
}
